



































































































import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
const {dataJson} = require('@/dataJson.js');


@Component({
  components: {
    HelloWorld
  }
})
export default class Home extends Vue {
  data () {
    return {
      data:dataJson,
      dataFilted:dataJson,
      textString:'',
      toolArray:[],
      typeArray:'All',
      coinString:'',
      pc_asideTop:0,
    }
  }
  radioToggle(event){
    let el = event.currentTarget;
    let now = el.getAttribute("value");
    if(this.coinString == now){
      this.coinString= '';
      this.dataFilted = this.dataFilted.sort(function (a,b) {
        return  a.id >  b.id ? 1 : -1;
      });
    }
  }
  filterFunction(){ 
      // if(this.toolArray.length == 0 && this.typeArray.length == 0){
      //     this.dataFilted = this.data;
      // }
      this.dataFilted = this.data;
      this.pc_asideTop = 0;
      window.scroll(0, 270);
      let toolFilterData =[];
      let typeFilterData =[];
      let typeString = [];
      typeString.push(this.typeArray);
      // console.log(typeString);
      let toolFilter = this.toolArray;
      for( let i = 0 ;i < this.dataFilted.length ; i++){
        if(toolFilter.length != 0){
          let data = this.dataFilted[i].tool.filter(function(item, index, array){
            for(let x in toolFilter){
              if(toolFilter[x]==item.type){
                return true;
              }
            }
            return false;
          });
          if(data.length !=0)toolFilterData.push(this.dataFilted[i].id);
        }
        if(typeString[0] != "All"){
          //將資料陣列與篩選類型陣列做比對，符合的項目塞入typeFilterData裡面
          let intersection = this.dataFilted[i].condition.filter(function(item, index, array){return item == typeString;});
          // // console.log(intersection);
          if(intersection.length == 1){
            typeFilterData.push(this.dataFilted[i].id);
          }
        }else{
          typeFilterData.push(this.dataFilted[i].id);
        }
      }
      
      let final_id;
      toolFilter.length != 0?final_id = toolFilterData.filter(v => typeFilterData.includes(v)):final_id=typeFilterData;
      // console.log(final_id);

      let textArray = this.textString.split(" ");
      // console.log(textArray);
      this.dataFilted = this.dataFilted.filter(function(item, index, array){
        let TrueNum = 0;
        for( let i = 0 ;i < final_id.length ; i++){
          if(final_id[i] == item.id){
            TrueNum++;
            break ;
          }
        };
        if(textArray.length != 0){
          let textNull =0;
          for( let i = 0 ;i < textArray.length ; i++){
            if(textArray[i]>0 && textArray[i]<=70){
              if(textArray[i] == item.id){
                TrueNum++;
                // console.log(TrueNum);
                break ;
              }
            }else {
              textNull++;
            }
          };
          if(textNull == textArray.length)TrueNum++;
        }else{
          TrueNum++;
        };
        return TrueNum == 2 ? true:false;
      });

      if(this.coinString != ''){
        let coin_num = this.coinString-1;
        this.dataFilted = this.dataFilted.sort(function (a,b) {
          let new_a = a.exchange[coin_num] > a.more_exchange[coin_num]?a.exchange[coin_num] :a.more_exchange[coin_num];
          let new_b = b.exchange[coin_num] > b.more_exchange[coin_num]?b.exchange[coin_num] :b.more_exchange[coin_num];
          let c = new_a <  new_b ? 1 : -1;
          return c;
        });        
      }
  }
  asideHeight(){
    let w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          h = w.innerWidth|| e.clientWidth|| g.clientWidth,
          y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    return h>960?y - 60: 'initial';
  }
  onScroll(){
    let w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          h = w.innerWidth|| e.clientWidth|| g.clientWidth,
          y = w.innerHeight|| e.clientHeight|| g.clientHeight;
    if(h>960){      
      if(window.scrollY + window.innerHeight > document.body.scrollHeight-20 && window.innerHeight + 500 < document.body.scrollHeight){
        this.pc_asideTop = document.body.scrollHeight - window.innerHeight - 290;
      }else if(window.scrollY<300){
        this.pc_asideTop = 0;
      }else{
        this.pc_asideTop = window.scrollY - 290;
      }
    }else{
      this.pc_asideTop = 0;
    }

    if(window.scrollY + window.innerHeight > document.body.scrollHeight -10){

      // console.log(y);
    }
  }
  mounted(){
    window.addEventListener('scroll',this.onScroll);
  }
  deforeDestroy(){
    window.removeEventListener('scroll',this.onScroll);
  }
}
